import { Div } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class Important extends Div
{
    constructor(content: appendable)
    {
        super();
        this.Style(`background-color: #fffa3b; padding: 12px; border-radius: 8px; margin-bottom: 12px; color: #222;`);
        this.Append(content);
    }
}
